import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[appFVBorder]'
})
export class ControlBorderDirective implements AfterViewInit {
  focused$ = new BehaviorSubject<boolean>(false);
  private focusChanged$ = new BehaviorSubject<boolean>(false);

  constructor(
    public elRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.focusChanged$.subscribe({
      next: (focusIn) => {
        if (!focusIn) {
          setTimeout(() => {
            if (this.focusChanged$.getValue() === false) {
              // console.log('Now Focus is lost');
              this.focused$.next(false);
            }
          }, 100);
        }

      }
    })
  }

  ngAfterViewInit() {
    this.renderer.listen(this.elRef.nativeElement, 'focusin', (e) => {
      // console.log('IN', e);
      this.focusChanged$.next(true);
      this.focused$.next(true);
    });
    this.renderer.listen(this.elRef.nativeElement, 'focusout', (e) => {
      // console.log('OUT', e);
      this.focusChanged$.next(false);
    });
  }
}
